<template>
  <div>
    <div
      v-if="!documents.length && !isAdding"
      class="bg-secondary-3 p-3 mt-4 rounded"
    >
      <div>
        <div class="upload-file-button__container">
          <div class="panel-row-without-selector p-4">
            <div class="col-12 text-center">
              <button
                v-if="!readOnly"
                class="btn bg-light-white col-12 col-md-4"
                @click="isAdding = true"
              >
                <em class="fas fa-file-plus pr-4 text-green" />
                <span class="text-button-add-document">
                  Presione aquí para anejar documento
                </span>
              </button>
              <div v-else class="text-center">
                <strong>No hay documentos anejados</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <add-document-row
        v-for="(document, index) in documents"
        :key="index"
        :document="document"
        :index="index"
        :read-only="readOnly"
        @on-download="onDownload"
        @on-remove="onRemove"
      />
    </div>
    <div v-if="isAdding" class="bg-secondary-3 p-3 mt-3 rounded">
      <validation-observer ref="documentObserver" class="row mx-2 " tag="div">
        <div class="col-md-4 col-sm-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.documentType"
              :class="{
                'was-Invalidated-select': !!errors[0],
              }"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Documento:"
              :options="availableDocumentTypes"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-4 col-sm-6 "
          :class="model.file && 'd-flex justify-content-center'"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              ref="fileUpload"
              v-model="model.file"
              :accept="allowedFiles"
              class="mt-4 pt-1"
              custom-error-msg="Favor seleccionar un documento."
              display-style="normal"
              :error="errors[0]"
              label=""
              label-position="left"
              :max-size="100"
              :on-download="() => {}"
              required
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <div class="mt-4 text-right">
            <action-button
              id="btnCancel"
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2"
              @click="closeAdding"
            >
              Cancelar
            </action-button>
            <action-button
              id="btnAdd"
              i="fas fa-file-plus"
              variant="success pl-4 pr-4"
              @click="onAdd"
            >
              Añadir
            </action-button>
          </div>
        </div>
      </validation-observer>
    </div>
    <div
      v-if="documents.length > 0 && !isAdding && !readOnly"
      class="d-flex justify-content-end mt-3"
    >
      <action-button
        i="fas fa-file-plus"
        variant="success"
        @click="isAdding = true"
      >
        Añadir
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import AddDocumentRow from './AddDocumentRow';
import service from '@/modules/app/api';

import alert from '@/mixins/alert.mixin';
import documentService from '@/modules/shared/documents.api.js';

export default {
  name: 'AddDocument',
  components: {
    CustomFileInput,
    ActionButton,
    CustomDropDown,
    AddDocumentRow,
  },
  mixins: [alert],
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    model: {
      documentType: null,
      file: null,
    },
    documentTypes: [],
    isAdding: false,
    allowedFiles: '.pdf',
  }),
  computed: {
    availableDocumentTypes() {
      const selectedIds = (this.documents || []).map((d) => {
        const dt = d.documentType;
        return dt && typeof dt === 'object' ? dt.id : dt;
      });

      return this.documentTypes.filter((t) => !selectedIds.includes(t.id));
    },
  },
  async mounted() {
    await this.getTypes();
  },
  methods: {
    async onAdd() {
      const isValid = await this.$refs.documentObserver.validate();
      if (!isValid) return;

      this.$emit('on-add-document', {
        documentType: this.model.documentType,
        file: this.model.file,
      });

      this.closeAdding();
    },
    async onDownload(document) {
      if (document.documentId != undefined) {
        service
          .downloadDocumentByAttachmentId(document.documentId)
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      } else {
        service.downloadFileInline(document.file);
      }
    },
    async onRemove(index) {
      this.$emit('on-remove-document', index);
    },
    async getTypes() {
      const { data } = await documentService.getDocumentTypes('GenerateLetter');
      this.documentTypes = data;
    },
    closeAdding() {
      this.isAdding = false;
      this.model.documentType = null;
      this.model.file = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';
</style>
